import Box from "../Box";
import { cn } from "@/common/utils/cn";
import Skeleton from "../Skeleton";
import Spinner from "../Spinner";

interface ResumeBoxProps {
  label?: string;
  value?: string | number | JSX.Element;
  boxClassName?: string;
  labelClassName?: string;
  valueClassName?: string;
  testId?: string;
  padding?: "small" | "medium";
  isLoading?: boolean;
  loadingStyle?: "skeleton" | "spinner";
  loadingMode?: "valueOnly" | "valueAndLabel";
  skeletonLabelWidth?: number;
  skeletonValueWidth?: number;
}

const ResumeBox = ({
  label,
  value,
  boxClassName,
  labelClassName,
  valueClassName,
  testId,
  padding = "medium",
  isLoading,
  loadingStyle = "skeleton",
  loadingMode = "valueAndLabel",
  skeletonLabelWidth,
  skeletonValueWidth,
}: ResumeBoxProps) => {
  return (
    <Box className={cn(
      'rounded-xl flex flex-col gap-1',
      padding === 'small' && 'px-3 py-3',
      padding === 'medium' && 'px-4 py-5',
      boxClassName
    )}
    >
      {isLoading && loadingMode === "valueAndLabel" ? (
        <>
          {loadingStyle === "skeleton" && (
            <>
              <Skeleton width={skeletonLabelWidth || Math.floor(Math.random() * (150 - 60) + 60)} height={16} />
              <Skeleton width={skeletonValueWidth || Math.floor(Math.random() * (150 - 60) + 60)} height={20} />
            </>
          )}

          {loadingStyle === "spinner" && (
            <div className="h-10 flex items-center justify-center">
              <Spinner className="size-6 fill-white-400 text-white-200" />
            </div>
          )}
        </>
      ) : (
        <>
          {label && (
            <p className={cn('text-xs font-light', labelClassName)}>
              {label}
            </p>
          )}

          {isLoading && loadingMode === "valueOnly" ? (
            <>
              {loadingStyle === "skeleton" && (
                <Skeleton width={skeletonValueWidth || Math.floor(Math.random() * (150 - 60) + 60)} height={20} />
              )}

              {loadingStyle === "spinner" && (
                <div className="h-5 flex items-center">
                  <Spinner className="size-4 fill-white-400 text-white-200" />
                </div>
              )}
            </>
          ) : value && (
            <p className={cn('text-sm font-medium', valueClassName)} data-testid={testId}>
              {value}
            </p>
          )}
        </>
      )}
    </Box>
  );
};

export default ResumeBox;
